import { useQuery } from '@apollo/client';
import { GET_DRP_IT_APPLICATIONS_SUMMARY } from '../graphql';
import type {
  GetItApplicationsSummaryData,
  GetItApplicationsSummaryVars,
  DrpApplication,
} from '../types';

/**
 * Hook to fetch IT applications summary data for DRP dashboard composition
 * Orchestrates domain data from IT Applications service for Cyber Hub DRP view
 * @param locationUUID - The UUID of the location to fetch the applications data for
 */
export const useDrpApplicationsData = (locationUUID: string) => {
  const result = useQuery<
    GetItApplicationsSummaryData,
    GetItApplicationsSummaryVars
  >(GET_DRP_IT_APPLICATIONS_SUMMARY, {
    variables: { locationUUID },
    skip: false, // Always run the query
  });

  if (result.error) {
    console.error('useDrpApplicationsData GraphQL error:', result.error);
  }

  const applications: DrpApplication[] =
    result.data?.getItApplicationsDashboard?.applications || [];

  return {
    applications,
    stats: result.data?.getItApplicationsDashboard?.cards,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
};
